export function valueToMoneyFloat(value) {
    return parseFloat(value).toFixed(2);
}
